// paymentHandlers.js
import { getCsrfToken } from "./csrf";
import { getDiscountedPrice } from "./price";
import { sendEmail } from "./email";
import { API_BASE_URL } from "../Config";

export async function handleCheckout({
  cart,
  deliveryAddress,
  clientName,
  clientSurname,
  setCart,
  setClientName,
  setShowAlert,
  setIsPaymentSuccess,
  i18n,
}) {
  try {
    const csrfToken = getCsrfToken();
    const languageLocale = i18n.language;

    // 1. Criar pedido
    const orderData = {
      client: localStorage.getItem("clientId"),
      shipping: localStorage.getItem("shippingCost"),
      order_date: new Date().toISOString().split("T")[0],
      order_closed: false,
      order_delivered: false,
    };

    const orderResponse = await fetch(`${API_BASE_URL}/api/order/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      body: JSON.stringify(orderData),
      credentials: "include",
    });

    const order = await orderResponse.json();
    const orderId = order.id;
    if (!orderId) throw new Error("Pedido não foi criado corretamente");

    // 2. Associar itens
    const itemPromises = cart.map((item) => {
      const finalPrice = getDiscountedPrice(item.product.real_price, item.product.discount);
      const itemData = {
        order: orderId,
        product_name: item.product.id,
        quantity: item.quantityInCart,
        price: finalPrice,
      };

      return fetch(`${API_BASE_URL}/api/orderitem/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        body: JSON.stringify(itemData),
        credentials: "include",
      });
    });

    await Promise.all(itemPromises);

    // 3. Enviar e-mail
    const discountedCart = cart.map((item) => ({
      ...item,
      product: {
        ...item.product,
        real_price: getDiscountedPrice(item.product.real_price, item.product.discount),
      },
    }));

    const emailResult = await sendEmail(
      discountedCart,
      clientName,
      clientSurname,
      localStorage.getItem("clientEmail"),
      localStorage.getItem("shippingCost"),
      localStorage.getItem("totalPriceWithShippingCost"),
      deliveryAddress,
      languageLocale,
      orderId
    );

    if (emailResult.status === "success") {
      setShowAlert(true);
      setClientName("");
      setCart([]);
      [
        "clientName", "clientId", "clientSurname", "clientEmail",
        "totalQuantityHeader", "cart", "clientAddress", "clientNumber",
        "clientAdditionalAddress", "clientPostalCode", "clientCity", "clientCountry"
      ].forEach(key => localStorage.removeItem(key));
    } else {
      alert("Falha ao enviar o email.");
    }
  } catch (error) {
    alert("Falha ao processar o checkout: " + error.message);
  } finally {
    setIsPaymentSuccess(true);
    window.scrollTo(0, 0);
  }
}


export function handleError(err) {
  console.error("Erro PayPal:", err);
  alert("Erro ao processar pagamento com PayPal");
}



export async function handleKlarnaPayment({ cart, totalPriceWithShippingCost }) {
  try {
    const response = await fetch(`${API_BASE_URL}/klarna/session/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCsrfToken(),
      },
      body: JSON.stringify({
        cart,
        totalPriceWithShippingCost,
        clientId: localStorage.getItem("clientId"),
      }),
      credentials: "include",
    });

    const data = await response.json();
    const orderId = data.order_id;
    if (!orderId) throw new Error("Pedido Klarna não foi criado corretamente");

    // ✅ Iniciar sessão Klarna (gera html_snippet no backend)
    await fetch(`${API_BASE_URL}/klarna/start/${orderId}`, {
      method: "GET",
      credentials: "include",
    });

    // ✅ Redirecionar para sua tela Klarna
    window.location.href = `/klarna/checkout/${orderId}`;

  } catch (err) {
    console.error("❌ Erro Klarna:", err);
    alert("Falha ao iniciar Klarna");
  }
}
